export default __webpack_public_path__ + "static/media/IMG3186.3ad30318.jpg";